import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import highlight from 'flarum/common/helpers/highlight';
import Button from 'flarum/common/components/Button';
export default class DiscussionSearchSource {
  constructor(onSelect, ignore) {
    _defineProperty(this, "results", new Map());
    _defineProperty(this, "onSelect", void 0);
    _defineProperty(this, "ignore", void 0);
    this.results = new Map();
    this.onSelect = onSelect;
    this.ignore = ignore;
  }
  search(query) {
    query = query.toLowerCase();
    this.results.set(query, []);
    const params = {
      filter: {
        q: query
      },
      page: {
        limit: 3
      }
    };
    const id = Number(query);
    if (!Number.isNaN(id) && id !== Number(this.ignore)) {
      return app.store.find('discussions', String(id)).then(d => {
        this.results.set(query, [d]);
      });
    }
    return app.store.find('discussions', params).then(results => {
      this.results.set(query, results.filter(d => d.id() !== this.ignore));
    });
  }
  view(query) {
    query = query.toLowerCase();
    return (this.results.get(query) || []).map(discussion => {
      return m("li", {
        className: "DiscussionSearchResult",
        "data-index": 'discussions' + discussion.id()
      }, m(Button, {
        onclick: () => this.onSelect(discussion)
      }, m("div", {
        className: "DiscussionSearchResult-id"
      }, discussion.id()), m("div", {
        className: "DiscussionSearchResult-title"
      }, highlight(discussion.title(), query))));
    });
  }
}
flarum.reg.add('sycho-uikit', 'forum/components/DiscussionSearchSource', DiscussionSearchSource);